/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CartaoConfirmarAliases {
  BUTTON_CONFIRMAR = 'button-confirmar',
  FRAGMENT_0 = 'fragment-0',
  LAYOUT_CARTAO_CONFIRMAR = 'layout-cartao-confirmar',
  LOADER_0 = 'loader-0',
  MODAL_PERGUNTA = 'modal-pergunta',
  PANEL_BUTTON = 'panel-button',
  PANEL_LOADER = 'panel-loader',
  PANEL_MODAL = 'panel-modal',
}
export { CartaoConfirmarAliases };
